import { useContext } from "react";
import { CachedTokenContext, s2Token } from "@seabrookstudios/auth";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import { useServerConfig } from "../config/ConfigProvider.js";
import { isEulaRequired } from "./isEulaRequired.js";

/**
 * @typedef {"idle"|"loading"|"not-required"|"required"} EulaGateStatus
 */

/**
 * @returns {{
 *   status: EulaGateStatus,
 *   latestVersion: import("@seabrookstudios/pitch2table-core").EULAVersion | undefined,
 * }}
 */
export const useEulaGateState = () => {
  const token = useContext(CachedTokenContext);
  const isAuthenticated = token !== s2Token("");

  const serverConfigQuery = useServerConfig();
  const entitlementsQuery = useMyEntitlements();

  if (!isAuthenticated) {
    return { status: "idle", latestVersion: undefined };
  }

  if (!serverConfigQuery.isSuccess || !entitlementsQuery.isSuccess) {
    return { status: "loading", latestVersion: undefined };
  }

  const latestVersion = serverConfigQuery.data.eulaVersion;
  const acceptedVersion = entitlementsQuery.data.eulaVersion;

  if (!isEulaRequired(latestVersion, acceptedVersion)) {
    return { status: "not-required", latestVersion: undefined };
  }

  return { status: "required", latestVersion };
};
